export default "__VITE_ASSET__DoiNjNZF__"